import { deleteData, getData, putData } from "./commonServices";
import {
  ADMIN_BATCHES,
  ADMIN_BATCH,
  ADMIN_BATCH_STATISTICS,
  BASE_URL,
} from "../serviceUrls";

// Helper to get token from localStorage
const getToken = () => localStorage.getItem("access_token");

// Custom function for form data uploads
const postFormData = (api, formData, token) => {
  const headers = {
    Accept: "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return fetch(`${BASE_URL}/${api}`, {
    method: "POST",
    headers,
    body: formData,
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        // Create an error object that includes the response data
        const error = new Error(
          data.error || data.message || `HTTP ${res.status}: ${res.statusText}`
        );
        error.response = { data, status: res.status };
        throw error;
      }

      return data;
    })
    .catch((error) => {
      // If it's already our custom error, re-throw it
      if (error.response) {
        throw error;
      }
      // Network error - return the original format for compatibility
      return { hasError: true, message: "Network error" };
    });
};

// Batches API Service
export const batchesAPI = {
  // Get all batch statistics
  getBatchStats: async () => {
    const token = getToken();
    return await getData(ADMIN_BATCH_STATISTICS, token);
  },

  // Get single batch by ID
  getBatch: async (batchId) => {
    const token = getToken();
    return await getData(`${ADMIN_BATCH}/${batchId}`, token);
  },

  // Update batch
  updateBatch: async (batchId, batchData) => {
    const token = getToken();
    return await putData(`${ADMIN_BATCH}/${batchId}`, batchData, token);
  },

  // Delete batch
  deleteBatch: async (batchId) => {
    const token = getToken();
    return await deleteData(`${ADMIN_BATCH}/${batchId}`, token);
  },

  // Add new batch with file upload
  addBatch: async (batchName, jsonFile) => {
    const token = getToken();
    const formData = new FormData();
    formData.append("batch_name", batchName);
    formData.append("json_file", jsonFile);

    return await postFormData("admin/add_batch", formData, token);
  },
};
